<div class="shop-details">
    <h2 class="shop-details__title">{{ctrl.shopName}}</h2>

    <div class="shop-details__location">
        <div class="shop-details__pin">
            <img ng-if="ctrl.shopTypesServ.isOrangeShop(ctrl.shopType) || ctrl.$location.absUrl().includes('tkr')"
                 class="img-responsive"
                 src="assets/shop-details/location-icon.gif">

            <img ng-if="ctrl.shopType === ctrl.shopTypesServ.getTypeOmMerchant() && ctrl.shopSubType === ctrl.shopTypesServ.getSubTypeFashion()"
                 class="img-responsive"
                 src="assets/map/markers/locationPinFashion.png"
                 srcset="assets/map/markers/locationPinFashion.png 1x, assets/map/markers/locationPinFashion@2x.png 2x, assets/map/markers/locationPinFashion@3x.png 3x"
                 alt="Moda">

            <img ng-if="ctrl.shopType === ctrl.shopTypesServ.getTypeOmMerchant() && ctrl.shopSubType === ctrl.shopTypesServ.getSubTypeSupermarket()"
                 class="img-responsive"
                 src="assets/map/markers/locationPinMarket.png"
                 srcset="assets/map/markers/locationPinMarket.png 1x, assets/map/markers/locationPinMarket@2x.png 2x, assets/map/markers/locationPinMarket@3x.png 3x"
                 alt="Supermarket">

            <img ng-if="ctrl.shopType === ctrl.shopTypesServ.getTypeOmMerchant() && ctrl.shopSubType === ctrl.shopTypesServ.getSubTypeRestaurants()"
                 class="img-responsive"
                 src="assets/map/markers/locationPinRestaurant.png"
                 srcset="assets/map/markers/locationPinRestaurant.png 1x, assets/map/markers/locationPinRestaurant@2x.png 2x, assets/map/markers/locationPinRestaurant@3x.png 3x"
                 alt="Restaurante">

            <img ng-if="ctrl.shopType === ctrl.shopTypesServ.getTypeOmMerchant() && ctrl.shopSubType === ctrl.shopTypesServ.getSubTypeFreeTime()"
                 class="img-responsive"
                 src="assets/map/markers/locationPinFreetime.png"
                 srcset="assets/map/markers/locationPinFreetime.png 1x, assets/map/markers/locationPinFreetime@2x.png 2x, assets/map/markers/locationPinFreetime@3x.png 3x"
                 alt="Timp liber">

            <img ng-if="ctrl.shopType === ctrl.shopTypesServ.getTypeOmMerchant() && ctrl.shopSubType === ctrl.shopTypesServ.getSubTypeHealth()"
                 class="img-responsive"
                 src="assets/map/markers/locationPinHealth.png"
                 srcset="assets/map/markers/locationPinHealth.png 1x, assets/map/markers/locationPinHealth@2x.png 2x, assets/map/markers/locationPinHealth@3x.png 3x"
                 alt="S&#259;n&#259;tate">

            <img ng-if="ctrl.shopType === ctrl.shopTypesServ.getTypeOmMerchant() && ctrl.shopSubType === ctrl.shopTypesServ.getSubTypeServices()"
                 class="img-responsive"
                 src="assets/map/markers/locationPinServices.png"
                 srcset="assets/map/markers/locationPinServices.png 1x, assets/map/markers/locationPinServices@2x.png 2x, assets/map/markers/locationPinServices@3x.png 3x"
                 alt="Servicii">

            <img ng-if="ctrl.shopType === ctrl.shopTypesServ.getTypeOmMerchant() && ctrl.shopSubType === ctrl.shopTypesServ.getSubTypeElectronics()"
                 class="img-responsive"
                 src="assets/map/markers/locationPinElectronics.png"
                 srcset="assets/map/markers/locationPinElectronics.png 1x, assets/map/markers/locationPinElectronics@2x.png 2x, assets/map/markers/locationPinElectronics@3x.png 3x"
                 alt="Electronice">

            <img ng-if="ctrl.shopType === ctrl.shopTypesServ.getTypeOmMerchant() && ctrl.shopSubType === ctrl.shopTypesServ.getSubTypeMarket()"
                 class="img-responsive"
                 src="assets/map/markers/locationPinGeneral.png"
                 srcset="assets/map/markers/locationPinGeneral.png 1x, assets/map/markers/locationPinGeneral@2x.png 2x, assets/map/markers/locationPinGeneral@3x.png 3x"
                 alt="Magazin">
        </div>
        <div class="shop-details__content">
            <h3 class="shop-details__alias"
                ng-if="ctrl.shopType === ctrl.shopTypesServ.getTypeOmMerchant()">{{ctrl.subTypeDescr}}</h3>
            <h3 class="shop-details__description">{{ctrl.shopDescription}}</h3>
            <p class="shop-details__program">{{ctrl.todaysProgram}}</p>
        </div>
    </div>

    <div class="shop-details__buttons">
        <a href="javascript:void(0);"
           class="shop-details__button btn btn-important"
           ng-show="ctrl.hasAppointment"
           ng-click="ctrl.scrollToHash('appointment-form')">
            Programeaz&#259;-te
        </a>
        <a class="shop-details__button btn"
           ng-href="{{ctrl.directionsUrl}}"
           target="_blank">
            Vezi unde se afl&#259;
        </a>
    </div>
</div>
